import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { FeedbackAthleteAnswerProvider } from '../../providers/feedback-athlete-answer-provider';
import { SimpleMatDataSource } from '../../../common/providers/simple-mat-data-source';
import { BreadcrumbProvider, Crumb } from '../../../breadcrumb/providers/breadcrumb-provider';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { UsersProvider } from '../../../users/providers/users-provider';
import { FeedbackRights, mapFeedbackItemRightsToRowRights } from '../../providers/feedback-rights';
import { CurrentUser } from '../../../common/providers/current-user';
import { CurrentUserRolesProvider } from '../../../organizations/providers/current-user-roles-provider';
import { Title } from '@angular/platform-browser';
import { ConfigProvider } from "../../../config-provider.service";
import { map, Observable, Subscription } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Paginator } from "../../../common/models/paginator";
import { FeedbackAthleteAnswer } from "../../../common/models/feedback-athlete-answer";
import { Organization } from "../../../common/models/organization";
import { Athlete } from "../../../common/models/athlete";
import { User } from "../../../common/models/user";
import { ModuleMenu } from "../../../common/models/menu";
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { OrganizationRole } from "../../../common/models/organization-role";
import { ConfirmDialogComponent } from "../../../common/components/confirm-dialog/confirm-dialog";
import { ApiBaseService } from "../../../common/providers/api-base-service";
import { PageContentComponent } from "../../../common/components/page-content/page-content";
import { HeaderComponent } from "../../../common/components/header-elitment/header-elitment";
import { SideMenuComponent } from "../../../common/components/side-menu/side-menu";
import { AthleteSideMenuComponent } from "../../../athletes/components/side-menu/side-menu";
import { Error401Component } from "../../../common/components/error-401/error-401";
import { Error404Component } from "../../../common/components/error-404/error-404";
import { NgIf } from "@angular/common";
import { MatFormField } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatIcon } from "@angular/material/icon";
import { MatTable, MatTableModule } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { ModuleContentComponent } from "../../../common/components/module-content/module-content";
import { AppDatePipe } from "../../../common/pipes/app-date";
import { FeedbackAthleteSmileyComponent } from "../../components/athlete-smiley/feedback-athlete-smiley.component";
import { MatIconButton } from "@angular/material/button";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { FlexLayoutModule } from "@angular/flex-layout";

@Component({
  selector: 'app-feedback-list-container',
  templateUrl: './feedback-list-container.component.html',
  styleUrls: ['./feedback-list-container.scss'],
  imports: [
    PageContentComponent,
    HeaderComponent,
    SideMenuComponent,
    AthleteSideMenuComponent,
    Error401Component,
    Error404Component,
    NgIf,
    TranslateModule,
    MatFormField,
    MatInput,
    MatIcon,
    MatTableModule,
    MatSort,
    ModuleContentComponent,
    RouterLink,
    AppDatePipe,
    FeedbackAthleteSmileyComponent,
    MatIconButton,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatPaginator,
    FlexLayoutModule
  ],
  standalone: true
})
export class FeedbackListContainerComponent implements OnInit, AfterViewInit, OnDestroy {
    public pageTitle = 'Tests';
    public isLoading = true;
    public is401 = false;
    public is404 = false;

    public dataSource: SimpleMatDataSource = new SimpleMatDataSource([]);
    public columns: string[] = ['name', 'createDate', 'mood', 'action'];
    public moodIconClass = 'athlete-smiley-icon medium-smiley material-icons';

    public organization: Organization = {} as Organization;
    public athleteUser: User = {} as User;

    public paginatedResults: Paginator =  {} as Paginator;
    public pageSize: number = FeedbackAthleteAnswer.NUM_ITEMS;
    public currentPage = 0;
    public totalSize = 0;

    public mainActions: ModuleMenu[] = [];
    public rights: FeedbackRights = new FeedbackRights(this.utils);
    private subscriptions: Subscription[] = [];

    @ViewChild(MatPaginator, {static: false}) public paginator: MatPaginator | undefined;

    constructor(
        private feedbackAthleteAnswerProvider: FeedbackAthleteAnswerProvider,
        private route: ActivatedRoute,
        private breadcrumbProvider: BreadcrumbProvider,
        private translator: TranslateService,
        private userProvider: UsersProvider,
        private dialog: MatDialog,
        private toaster: MatSnackBar,
        private utils: UtilsProvider,
        private currentUser: CurrentUser,
        private currentUserRoles: CurrentUserRolesProvider,
        private title: Title,
        private api: ApiBaseService,
        public conf: ConfigProvider,
    ) {
    }

    public ngOnInit(): void {
        this.subscriptions.push(
            this.route.data.subscribe((data: any) => { //{ organization: Organization; athlete: Athlete }

                this.organization = data.organization;
                this.athleteUser = data.athlete;

                this.loadPaginatedData().subscribe(() => {

                    this.rights.evaluateScreenRights({
                        rolesIds: this.currentUserRoles.getRolesIds(this.organization.id!)
                    });

                    if (!this.rights.LIST) {
                        this.is401 = true;
                    }

                    if (this.rights.ADD) {
                        this.mainActions = [
                            {
                                title: 'Add',
                                icon: 'add',
                                url: '/' + this.organization!.code + '/athletes/' + this.athleteUser.id + '/feedback/daily/new',
                                onClick: null
                            }
                        ];
                    }

                    this.createPageTitle();
                    this.createBreadcrumb();
                    this.isLoading = false;
                });
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    public ngAfterViewInit(): void {
        this.dataSource.paginator = this.paginator!;
    }

    public loadPaginatedData(page = 0, query = ''): Observable<any> {
      return this.feedbackAthleteAnswerProvider.findAllByOrganizationAndAthletePaginated(this.organization, this.athleteUser.athlete!, page, query).pipe(
        map((paginator: Paginator) => {
          this.paginatedResults = paginator;
          this.currentPage = this.paginatedResults.current_page - 1;
          this.pageSize = this.paginatedResults.per_page;
          this.totalSize = this.paginatedResults.total;

          this.paginatedResults.data.forEach((feedback) => {
            feedback.rights = mapFeedbackItemRightsToRowRights(feedback.rights ?? []);
          });

          this.dataSource.replaceAllWith(this.paginatedResults.data);
        })
      );
    }


    /**
     * Perform a new request for the requested page
     *
     * @param event
     */
    public onPaginateChange(event:any) {
        this.loadPaginatedData(event.pageIndex + 1).subscribe();
    }

    public onFilterKeyup(filter: string): void {
        this.loadPaginatedData(0, filter).subscribe();
    }

    public onDeleteClicked(row:any ) {
        const dialog: MatDialogRef<ConfirmDialogComponent> = this.dialog.open(ConfirmDialogComponent, {
            data: {
                confirmText: 'FeedbackConfirmDelete',
                confirmActionText: 'Delete',
                confirmColor: 'primary'
            }
        });
        this.subscriptions.push(
            dialog.afterClosed().subscribe((confirmed: boolean) => {
                if (confirmed) {
                    this.subscriptions.push(
                        this.feedbackAthleteAnswerProvider.deleteById(this.organization, row.id).subscribe(
                            () => {
                                this.toaster.open(this.translator.instant('Feedback_Deleted'), '', {duration: 5000});
                                this.loadPaginatedData(this.currentPage + 1).subscribe();
                            },
                            (err) => {
                                this.toaster.open(err.error.message, '', { duration: 5000 });
                            })
                    );
                }
            })
        );
    }

    private createPageTitle(){
        this.pageTitle = this.translator.instant('Feedback_list');
        this.title.setTitle(this.pageTitle + ' | ' + this.conf.platformName);
    }

    private createBreadcrumb() {

        const crumbs: Crumb[] = [];
        if (!this.currentUserRoles.have(OrganizationRole.ID_ATHLETE, this.organization.id!)){
            crumbs.push({
                shortTitle: 'Athletes',
                title: 'Athletes',
                url: '/' + this.organization!.code + '/athletes'
            });
        }
        crumbs.push({
            shortTitle: `${this.athleteUser.firstName?.substr(0, 1)}. ${this.athleteUser.lastName}`,
            title: `${this.athleteUser.firstName} ${this.athleteUser.lastName}`,
            url: `/${this.organization!.code}/athletes/${this.athleteUser.id}`
        });
        crumbs.push({
            shortTitle: 'Feedback',
            title: 'FeedbackAll',
            url: ''
        });
        this.breadcrumbProvider.setDefaultCrumbs(crumbs);
    }
}
